import { render, staticRenderFns } from "./upgradeservice.vue?vue&type=template&id=00d8a6ab&scoped=true"
import script from "./upgradeservice.vue?vue&type=script&lang=js"
export * from "./upgradeservice.vue?vue&type=script&lang=js"
import style0 from "./upgradeservice.vue?vue&type=style&index=0&id=00d8a6ab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d8a6ab",
  null
  
)

export default component.exports